import jsCookie from 'js-cookie';
import { COOKIES, ADDONS } from '../constants';
import { isPackageFree, isPackagePro } from './displayHelpers';

export const setCookieWithDomain = (cookieName, value) => {
  if (window.location.href.indexOf('.com') > -1) {
    const currentHost = window.location.hostname;
    // set to .environment.sendgrid.com
    const cookieDomain = currentHost.substr(currentHost.indexOf('.'), currentHost.length);
    jsCookie.set(cookieName, value, { domain: cookieDomain });
  } else {
    jsCookie.set(cookieName, value);
  }
};

export const getParsedCookie = (cookieName) => {
  let cookie = jsCookie.get(cookieName) || {};
  if (cookie) {
    try {
      cookie = JSON.parse(decodeURI(cookie));
    } catch (err) {
      cookie = {};
    }
  }
  return cookie;
};

export const hasIP = () => {
  const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);

  return parsedCookie &&
    parsedCookie.addons &&
    parsedCookie.addons[ADDONS.DEDICATED_IP] &&
    parsedCookie.addons[ADDONS.DEDICATED_IP] > 0 &&
    parsedCookie.packages &&
    parsedCookie.packages.default &&
    isPackagePro(parsedCookie.packages.default);
};

export const hasEase = () => {
  const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);

  return parsedCookie.addons &&
    parsedCookie.addons[ADDONS.EASE] &&
    parsedCookie.addons[ADDONS.EASE] > 3 &&
    parsedCookie.packages &&
    parsedCookie.packages.default &&
    !isPackageFree(parsedCookie.packages.default);
};

export const setStringifiedCookie = (cookieName, json) => {
  let stringifiedJson = '';
  try {
    stringifiedJson = encodeURI(JSON.stringify(json));
  } catch (err) {
    stringifiedJson = '';
  }

  setCookieWithDomain(cookieName, stringifiedJson);
};

export const getEstimatedFromPricing = (type) => {
  const pricingCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  if (pricingCookie.estimations && pricingCookie.estimations[type]) {
    return pricingCookie.estimations[type];
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/cookieHelpers.js